export const coreAnalyticsEventName = 'core-analytics-event';

export const errorMessages = {
  trackerUndefined: 'Analytics: Tracker is undefined',
  trackerNotAFunction: 'Analytics: Tracker must be a function',
};

export default class RegisterAnalyticsEvents {
  /**
   * Constructor
   * Assigns the tracker and set up the event listeners
   * @param {Function} tracker - tracker function to be used
   */
  constructor(tracker) {
    if (!tracker) {
      throw new Error(errorMessages.trackerUndefined);
    }

    if (typeof tracker !== 'function') {
      throw new Error(errorMessages.trackerNotAFunction);
    }

    this.tracker = tracker;
    this.events = {};
    this.boundEventListener = this.onEvent.bind(this);

    this.attachEventListener();
  }

  /**
   * Initializes the events
   * @param {Object}   options         - Destructed option arguments
   * @param {Object}   options.events  - Key, value (event name, event) pairs of events to register
   * @param {String}   options.origin  - Origin, in most cases referred to the application
   *                                     e.g. 'index' for indexpage
   */
  init({ origin, events }) {
    this.events = events;
    this.origin = origin;
  }

  /**
   * Adds events, used to add events after initialization
   */
  addEvents(events) {
    this.events = { ...this.events, ...events };
  }

  /**
   * Attaches the 'core-analytics-event' event listener
   */
  attachEventListener() {
    window.addEventListener(coreAnalyticsEventName, this.boundEventListener);
  }

  /**
   * Detaches the 'core-analytics-event' event listener
   */
  detachEventListener() {
    window.removeEventListener(coreAnalyticsEventName, this.boundEventListener);
  }

  /**
   * Event callback
   *
   * @param {CustomEvent} event - Event passed from the event listener
   */
  onEvent(event) {
    if (!event || !event.detail) {
      return;
    }

    const analyticsEvent = this.events[event.detail.name];

    if (analyticsEvent) {
      const payload = { origin: this.origin, ...event.detail.payload };

      // Events can attach custom payload by wrapping the event data in a function
      // which will also always attach the origin inside the payload
      const compiledEvent = typeof analyticsEvent === 'function' ?
        analyticsEvent(payload) :
        analyticsEvent;
      this.tracker(compiledEvent);
    }
  }
}
